module.exports = __webpack_public_path__ + "img/tools_forecast_banner.7c6afd26.jpg";